import React from "react";
import ModalNew from "../../../components/Modal/ModalNew";
import formatText from "../../../utility/formatText";
import { Link } from "react-router-dom";
import { Feature } from "../../../store/types/settings";

const AgreementModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  billingType: "Monthly" | "Quarterly" | "Yearly";
  selectedFeatures: Feature[];
  selectedDirectAddOnIds: string[];
  title: string;
  tier: string;
  id: string;
  link: string;
}> = ({ isOpen, onClose, onConfirm, title, tier, id, link }) => {
  return (
    <ModalNew isOpen={isOpen} onClose={onClose} title={title}>
      <div className="p-2">
        <p className="text-xl font-medium pb-3">
          25th & Staffing Terms of Service
        </p>
        <p className="text-[14px] text-gray-500">
          By subscribing to {formatText(tier)} plan, you agree to the{" "}
          {/* <Link to={link} className="text-primary underline">
            Agreement
          </Link>{" "} */}
          and the{" "}
          <Link to={`/terms`} className="text-primary underline">
            Terms and Conditions
          </Link>
          . Note: The{" "}
          <Link to={`/data-encryption`} className="text-primary underline">
            Data Encryption Policy
          </Link>{" "}
          describes how data is handled in this service.
        </p>
        <div className="flex justify-end items-center gap-5 mt-4">
          <p
            className="text-[16px] cursor-pointer text-primary"
            onClick={onClose}
          >
            Cancel
          </p>
          <p
            className="text-[16px] cursor-pointer text-primary"
            onClick={onConfirm}
          >
            Agree
          </p>
        </div>
      </div>
    </ModalNew>
  );
};

export default AgreementModal;
